import {AdminDashboardScope} from '@features/admin-panel/models/admin-dashboard.models';

/** The test clusters, by their runtime `Environment` (dynamicsettings); production is `l2`. */
const TEST_CLUSTER_ENVIRONMENTS = ['dev', 'qa', 'stage'];

/**
 * The scope the Admin dashboard opens on (ITP-E-133-04): Non-clients on the dev, QA and stage clusters, whose Client
 * Manager holds no real clients, and Clients everywhere else, including production and an unknown environment.
 */
export function defaultAdminDashboardScope(environment: string | null | undefined): AdminDashboardScope {
  return TEST_CLUSTER_ENVIRONMENTS.includes((environment ?? '').trim().toLowerCase()) ? 'NonClients' : 'Clients';
}
